/**
 * Base configuration constants
 * Centralized configuration for API endpoints and URLs
 */

// Production API endpoints
export const DEFAULT_BASE_URL = "https://router.morpheum.io";
export const DEFAULT_WS_URL = "wss://router.morpheum.io/websocket";

// Default device ID for WebSocket connections
export const DEFAULT_DEVICE_ID = "ios-device-1234567890";

